import moment from 'moment';
export const checkRemissType = (referralId, referralData = null, referrals = []) => {
    if (!referralId) return null;
    let referral = referralData?.remissType ? referralData : referrals.find(r => r._id === referralId);
    let remissType = referral?.remissType ? referral.remissType : null;
    return remissType;
}

export const isDurationHideCheckboxAvailable = (referralId, referralData = null, referrals = []) => {
    const remissType = checkRemissType(referralId, referralData, referrals);
    if (!remissType) return false;
    return ['Klinikbokning', 'Revisit'].includes(remissType) ? true : false;
}

export const getCaseTimeForPatient = (caseData, getStringDateTs, dateFormat = 'YYYY-MM-DD', excludeStatuses = [], lang = 'se') => {
    if (!getStringDateTs) return { error: true };

    const hideTimeFromThePatient = caseData?.hideTimeFromThePatient || false;
    const hideDurationForPatient = caseData?.hideDurationForPatient || false;
    const status = caseData?.status || null;
    if (!status || excludeStatuses.includes(status)) {
        return null;
    }
    let startTs = null, endTs = null;
    if (status === 'disallowed') startTs = caseData.disallowedTimestamp;
    else if (status === 'return-for-update') startTs = caseData.returnTimestamp;
    else if (status === 'allowed') startTs = caseData.allowedTimestamp;
    else if (status === 'patient-requested-another-time') startTs = caseData.patientRequestTimeTimestamp;
    else if (status === 'patient-rejected') startTs = caseData.patientRejectedTimestamp;
    else if (status === 'patient-accepted') startTs = caseData.patientAcceptedTimestamp;
    else if (status === 'clinic-accepted-requested-time') startTs = caseData.clinicAcceptedTimestamp;
    else if (status === 'clinic-rejected-requested-time') startTs = caseData.clinicRejectedTimestamp;
    else if (status === 'approved-by-region-manager') startTs = caseData.approvedByRegionManagerTimestemp;
    else if (status === 'canceled-by-region-manager') startTs = caseData.canceledByRegionManagerTimestemp;
    else if (status === 'scheduled' || status === 'visit-rescheduled' || status === 'revisit-scheduled') {
        startTs = caseData.patientReservedTimestamp;
        endTs = caseData.endPatientReservedTimestamp;
    }
    else if (status === 'not-booked') startTs = caseData.notBookedTimestamp;
    else if (status === 'closed') startTs = caseData.closedTimestamp;
    else if (status === 'in-progress') startTs = caseData.inProgressTimestamp;
    else if (status === 'canceled-by-clinic') startTs = caseData.canceledByClinicTimestamp;
    else if (status === 'requested-new-appointment') startTs = caseData.patientRequestedNewAppointment;

    let date = getStringDateTs ? getStringDateTs(startTs, dateFormat) : null;
    let startTime = hideTimeFromThePatient ? null : getStringDateTs ? getStringDateTs(startTs, 'HH:mm') : null;
    let endTime = (hideTimeFromThePatient || hideDurationForPatient) ? null : (endTs && getStringDateTs ? getStringDateTs(endTs, 'HH:mm') : null);
    let duration = (hideTimeFromThePatient || hideDurationForPatient) ? null : (startTs && endTs ? Math.round((endTs - startTs) / 60) : null);

    let response = date;
    if (startTime && endTime && duration) {
        response += ` ${startTime}-${endTime} (${duration} ${'min'.translate(lang)})`;
    } else if (startTime) {
        response += ` ${startTime}`;
    }
    return response;
}

export const getTimeForPatient = (ts, endTs, hideTimeFromThePatient = false, hideDurationForPatient = false, getStringDateTs, dateFormat = 'YYYY-MM-DD', lang = 'se', isDoctor = false) => {
    if (!getStringDateTs) return { error: true };
    if (isDoctor) {
        hideTimeFromThePatient = false;
        hideDurationForPatient = false;
    }

    let date = getStringDateTs ? getStringDateTs(ts, dateFormat) : null;
    let startTime = hideTimeFromThePatient ? null : getStringDateTs ? getStringDateTs(ts, 'HH:mm') : null;
    let endTime = (hideTimeFromThePatient || hideDurationForPatient) ? null : (endTs && getStringDateTs ? getStringDateTs(endTs, 'HH:mm') : null);
    let duration = (hideTimeFromThePatient || hideDurationForPatient) ? null : (ts && endTs ? Math.round((endTs - ts) / 60) : null);

    let response = date;
    if (startTime && endTime && duration) {
        response += ` ${startTime}-${endTime} (${duration} ${'min'.translate(lang)})`;
    } else if (startTime) {
        response += ` ${startTime}`;
    }
    return response;

}


export const checkContinuesEarlierOrLaterEvents = (minTs) => {

    // console.log('================= checkContinuesEarlierOrLaterEvents =================');

    const className = 'rbc-events-container';
    const containers = document.getElementsByClassName(className);

    for (let i = 0; i < containers.length; i++) {
        // 1. clear previously styled divs and restore original values
        // const old = containers[i].querySelectorAll('.cf-stacked-earlier, .cf-stacked-later');
        // if (old?.length)
        //     console.log('old', old)
        // old.forEach(el => {
        //     console.log(el.dataset)
        //     el.style.position = el.dataset.cfOrigPosition || "";
        //     el.style.left = el.dataset.cfOrigLeft || "";
        //     el.style.width = el.dataset.cfOrigWidth || "";
        //     if (el.classList.contains("cf-stacked-earlier")) {
        //         // only earlier has top saved
        //         el.style.top = el.dataset.cfOrigTop || "";
        //     }
        //     el.classList.remove("cf-stacked-earlier");
        //     el.classList.remove("cf-stacked-later");
        // });

        const divs = containers[i].getElementsByClassName('rbc-event');
        // for (let j = 0; j < divs.length; j++) {
        //     const div = divs[j];
        //     console.log('restoring div', JSON.stringify({
        //         left: div?.dataset.cfOrigLeft,
        //         width: div?.dataset.cfOrigWidth,
        //         position: div?.dataset.cfOrigPosition,
        //         top: div?.dataset.cfOrigTop,
        //     }, null, 2));
        //     if (div.dataset.cfOrigLeft) {
        //         div.style.left = div.dataset.cfOrigLeft;
        //         delete div.dataset.cfOrigLeft;
        //     }
        //     if (div.dataset.cfOrigWidth) {
        //         div.style.width = div.dataset.cfOrigWidth;
        //         delete div.dataset.cfOrigWidth;
        //     }
        //     if (div.dataset.cfOrigPosition) {
        //         div.style.position = div.dataset.cfOrigPosition;
        //         delete div.dataset.cfOrigPosition;
        //     }
        //     if (div.dataset.cfOrigTop) {
        //         div.style.top = div.dataset.cfOrigTop;
        //         delete div.dataset.cfOrigTop;
        //     }
        //     div.classList.remove("cf-stacked-earlier");
        //     div.classList.remove("cf-stacked-later");
        // }
        if (divs?.length) {
            let earlierArr = [];
            let laterArr = [];
            let closeToEarlierArr = [];

            const minString = minTs ? moment.unix(minTs).format('HH:mm') : null;
            const minValue = minString?.length === 5 ? (Number(minString.split(':')[0]) * 60 + Number(minString.split(':')[1])) : null;

            for (let j = divs.length - 1; j >= 0; j--) {
                const div = divs[j];
                const match = div.className.match(/rbc-event-ts-(\d+)/);
                const ts = match ? Number(match[1]) : null;
                const eventString = ts ? moment.unix(ts).format('HH:mm') : null;
                const eventValue = eventString?.length === 5 ? (Number(eventString.split(':')[0]) * 60 + Number(eventString.split(':')[1])) : null;
                // 2. save original styles
                // if (div.style.left) div.dataset.cfOrigLeft = div.style.left;
                // if (!div.dataset.cfOrigWidth) div.dataset.cfOrigWidth = div.style.width;
                // if (!div.dataset.cfOrigPosition) div.dataset.cfOrigPosition = div.style.position;

                if (div.className.indexOf('rbc-event-continues-earlier') !== -1) {
                    // if (!div.dataset.cfOrigTop) div.dataset.cfOrigTop = div.style.top; // only for earlier
                    earlierArr.push({ div, ts });
                } else if (div.className.indexOf('rbc-event-continues-later') !== -1) {
                    laterArr.push({ div, ts });
                } else {
                    if (minValue && eventValue && eventValue <= (minValue + 10)) {
                        closeToEarlierArr.push({ div, ts, closeToEarlier: true });
                    }
                    // if width less then 50% set width to 100%
                    const widthPercent = parseFloat(div?.style?.width);
                    if (widthPercent && widthPercent < 100 || parseFloat(div?.style?.left) > 0) {
                        div.style.width = "100%";
                        div.style.left = "0";
                    }
                    if (div.dataset.cfOrigLeft) {
                        div.style.left = div.dataset.cfOrigLeft;
                        delete div.dataset.cfOrigLeft;
                    }
                }
            }
            if (closeToEarlierArr?.length && earlierArr?.length) {
                // merge closeToEarlierArr into earlierArr
                earlierArr = earlierArr.concat(closeToEarlierArr);
                // sort earlierArr again
                earlierArr.sort((a, b) => a.ts - b.ts);
            }

            // 3. sort and layout for earlier
            if (earlierArr.length) {
                earlierArr.sort((a, b) => a.ts - b.ts);
                const total = earlierArr.length;
                const widthPercent = 100 / total;
                earlierArr.forEach((item, index) => {
                    item.div.style.position = "absolute";
                    if (!item.closeToEarlier)
                        item.div.style.top = "0"; // earlier goes at top 0
                    item.div.style.left = `${index * widthPercent}%`;
                    item.div.style.width = `${widthPercent}%`;
                    item.div.classList.add("cf-stacked-earlier");
                });
            }

            // 4. sort and layout for later
            if (laterArr.length) {
                laterArr.sort((a, b) => a.ts - b.ts);
                const total = laterArr.length;
                const widthPercent = 100 / total;
                laterArr.forEach((item, index) => {
                    item.div.style.position = "absolute";
                    // top remains as set by the library
                    item.div.style.left = `${index * widthPercent}%`;
                    item.div.style.width = `${widthPercent}%`;
                    item.div.classList.add("cf-stacked-later");
                });
            }
        }
    }

    // console.log('-------------------------------------------------');
}
